import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

@Injectable()
export class LoginService extends TokenCommonService {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }


  authentication (mail: string, password: string) {
    return this.http.post(`${ environment.API_URL }auth/login`, {email: mail, password: password})
      .map(res => {
        return res.json().data;
      });
  }

  cerrarSesion() {
    return this.tokenPost(`${ environment.API_URL }auth/logout`);
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/login/login.service.ts